import { useMemo } from 'react';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { AlertList } from './AlertList';
import { AlertContext } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AlertProvider({
  children
}) {
  const store = useMemo(() => {
    return FloatingAlertStore.newFloatingAlertStore();
  }, []);
  const addAlert = alert => {
    store.addAlert(alert);
  };
  return /*#__PURE__*/_jsxs(AlertContext.Provider, {
    value: {
      store,
      addAlert,
      isInitialized: true
    },
    children: [/*#__PURE__*/_jsx(AlertList, {
      alertStore: store
    }), children]
  });
}